import { VenetianMask } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useImpersonation } from "@/lib/hooks/useImpersonation";

interface ImpersonationBannerProps {
    targetNome: string;
    targetEmail: string;
    topClassName?: string;
}

export function ImpersonationBanner({ targetNome, targetEmail, topClassName = "top-0" }: ImpersonationBannerProps) {
    const { isLoading, stopImpersonation } = useImpersonation();

    return (
        <div
            className={`fixed left-0 right-0 z-[60] h-12 flex items-center justify-center gap-3 bg-info-bg text-info text-body font-medium ${topClassName}`}
            role="banner"
        >
            <VenetianMask className="h-4 w-4" aria-hidden />
            <span>
                Visualizando como <strong>{targetNome}</strong> ({targetEmail})
            </span>
            <Button size="sm" variant="secondary" onClick={stopImpersonation} disabled={isLoading}>
                {isLoading ? "Voltando…" : "Voltar à minha conta"}
            </Button>
        </div>
    );
}
